import PropTypes from 'prop-types'
import React from 'react'
import isNil from 'lodash/isNil'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import { ROUTES } from '@/checkout-instore-legacy/constants/RoutesConstants'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'
import { sendEvent } from '@/checkout-instore-legacy/utils/WebViewBridge'
import * as CustomEvent from '@/checkout-instore-legacy/utils/CustomEvent'
import DefaultButton from '../DefaultButton'
import SearchBar from '../SearchBar'
import { NewSaleModalDialog } from '../../../../share/components/NewSaleModalDialog'

class Content extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      allowAnonymousUser:
        getInstoreConfig().allowAnonymousUser !== undefined
          ? getInstoreConfig().allowAnonymousUser
          : false,
    }
  }

  buttonTypes = {
    none: () => null,
    back: () => (
      <DefaultButton id="topbar-back" icon="back" onClick={this.props.onBack} />
    ),
    hamburger: () => (
      <DefaultButton
        id="topbar-hamburger"
        icon="nc-menu-34"
        onClick={this.handleHamburgerClick}
      />
    ),
    close: () => (
      <DefaultButton
        id="topbar-close"
        icon="close"
        onClick={this.props.onClose}
      />
    ),
  }

  getButton = (type) => (isNil(type) ? null : this.buttonTypes[type]())

  handleHamburgerClick = () => {
    this.props.setSidebarVisibility(true)
  }

  handleScanClick = () => {
    sendEvent({
      type: 'openBarcodeCameraVisible',
    })
  }

  handleSearchIconClick = () => {
    logClickEvent('click-search-button', 'Sale')
    this.props.router.push('/search')
  }

  componentDidMount() {
    CustomEvent.listenEvent('config.updated', this.handleConfigUpdated)
  }

  componentWillUnmount() {
    CustomEvent.unlistenEvent('config.updated', this.handleConfigUpdated)
  }

  handleConfigUpdated = () => {
    this.setState({
      allowAnonymousUser: getInstoreConfig().allowAnonymousUser,
    })
  }

  render() {
    const {
      leftButton,
      rightButton,
      showSearch,
      showBarcode,
      showTitle,
      title,
      titleId,
      mediaQuery,
      mode,
    } = this.props

    const { allowAnonymousUser } = this.state

    const isModal = mode === 'modal'

    const hasWindowTitle = title !== null || titleId !== null
    const { topbarTitle: customTitle } = getInstoreConfig()
    const hasCustomTitle = !isNil(customTitle)
    let displayTitle = 'VTEX Sales App'
    if (hasWindowTitle) {
      displayTitle = title !== null ? title : <FormattedMessage id={titleId} />
    } else if (hasCustomTitle) {
      displayTitle = customTitle
    }

    const searchCollapsed = mediaQuery({
      tablet: true,
      desktop: false,
    })

    const bigTitle = mediaQuery({
      tablet: false,
      desktop: isModal,
    })

    const isMobile = mediaQuery({
      mobile: true,
      tablet: true,
      desktop: false,
    })

    const { pathname, query } = this.props.location
    const term = query && query.term
    const isIdentificationPage = pathname === ROUTES.HOME
    const isSearchPage = pathname === ROUTES.SEARCH

    const searchBeforeIdentificationDisabled =
      isIdentificationPage && !allowAnonymousUser

    const showSearchField =
      showSearch &&
      (!searchCollapsed || this.props.mode === 'search') &&
      !searchBeforeIdentificationDisabled

    const showTitleComponent = !searchCollapsed || !showSearchField

    const showSearchButton =
      showSearch &&
      searchCollapsed &&
      !showSearchField &&
      !searchBeforeIdentificationDisabled

    const showBarcodeOnMobileRoute = showBarcode && isMobile
    const showBarcodeOnSearchRoute = isSearchPage && isMobile && !term
    const showBarcodeButton =
      showBarcodeOnMobileRoute ||
      (showSearchButton && !isIdentificationPage) ||
      showBarcodeOnSearchRoute

    const showNewSaleModalDialog =
      this.props.location.pathname === '/cart' ||
      this.props.location.pathname === '/payment'

    return (
      <div className="flex w-100 justify-between">
        <div className="flex flex-auto items-center">
          {this.getButton(leftButton)}
          <div
            className={`relative flex flex-auto items-center h-100 w-100 ${classnames(
              { pl5: leftButton === 'none' }
            )}`}
          >
            {showTitleComponent && (
              <div
                className={`${bigTitle ? 'f2' : 'f4'} flex flex-grow noselect
                  ${hasWindowTitle ? '' : 'title-logo'}`}
              >
                {showTitle && displayTitle}
              </div>
            )}

            {showSearchField && (
              <div className="w-40-l flex flex-auto flex-none-l mr5">
                <SearchBar {...this.props} />
              </div>
            )}
          </div>
          <div className="flex">
            {showBarcodeButton && (
              <DefaultButton
                id="scan-button"
                icon="barcode"
                onClick={this.handleScanClick}
              />
            )}
            {showSearchButton && (
              <DefaultButton
                id="search-button"
                icon="nc-zoom-2"
                onClick={this.handleSearchIconClick}
              />
            )}
          </div>
          {/* For a next refatoring, add use of ReactPortals.*/}
          {showNewSaleModalDialog && <NewSaleModalDialog variant="tertiary" />}
          {this.getButton(rightButton)}
        </div>
      </div>
    )
  }
}

const availableButtonTypes = ['none', 'back', 'hamburger', 'close']

Content.propTypes = {
  setSidebarVisibility: PropTypes.func.isRequired,
  location: PropTypes.object,
  router: PropTypes.object,
  leftButton: PropTypes.oneOf(availableButtonTypes),
  rightButton: PropTypes.oneOf(availableButtonTypes),
  showSearch: PropTypes.bool,
  showBarcode: PropTypes.bool,
  showTitle: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  titleId: PropTypes.string,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  mediaQuery: PropTypes.func,
  mode: PropTypes.string,
}

Content.defaultProps = {
  leftButton: 'none',
  rightButton: 'none',
  showSearch: false,
  showTitle: true,
  title: null,
  titleId: null,
  mode: 'normal',
}

export default withMediaQuery(withRouter(Content))
